export default "__VITE_ASSET__CgxGAQbQ__"